module.exports = __webpack_public_path__ + "static/home-transport-image-c3db9a7232f2ba8e43edeca3c4122675.svg";